// The frame of every public page (sign-in, sign-up, password reset, Shopify
// pages): light and centered — the lavender canvas, the logo, one white card,
// a discreet footer (Kevin, 2026-10-28: no brand panel, no marketing text).
import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandMark from '../BrandMark';
import './auth.css';

const AuthLayout = ({ heading, subheading, children, footer, wide }) => {
  const { t } = useTranslation();
  return (
    <div className="auth-page">
      <div className="auth-lockup">
        <BrandMark className="auth-lockup-mark" size={32} />
        <span>Unanimity</span>
      </div>
      <main className={`auth-card ${wide ? 'auth-card--wide' : ''}`}>
        <h1 className="auth-heading">{heading}</h1>
        {subheading && <p className="auth-subheading">{subheading}</p>}
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
      </main>
      <nav className="auth-legal" aria-label={t('publicUi.legalNav', 'Liens')}>
        <a href="/privacy-policy">{t('publicUi.privacy', 'Confidentialité')}</a>
        <span aria-hidden="true">·</span>
        <a href="mailto:support@unanimity.ai">support@unanimity.ai</a>
      </nav>
    </div>
  );
};

export default AuthLayout;
